import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { CheckBox, colors } from 'design-system';
import { useEffect, useState } from 'react';
// Models
import { useNetworkObserver } from 'data-layer-cr/dist/network';
// Redux related
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { QuotationUnit } from 'data-layer-cr/dist/models';
import { HelpCircle } from 'react-feather';
import { REQUEST_PRICING } from 'src/store/quotation/requestIdentifiers';
import { ExemptionCoverageModal } from './ExemptionCoverageModal';

const useStyles = makeStyles(() => {
  const nullBorder = 'none 0px transparent';
  return {
    labelStyle: {
      color: '#0D2041',
      lineHeight: '22px',
      fontSize: '15px',
      fontWeight: 700,
    },
    newLabelStyle: {
      color: '#27AE60',
      lineHeight: '22px',
      fontSize: '15px',
      fontWeight: 700,
    },
    divider: {
      borderRight: nullBorder,
      borderLeft: nullBorder,
      borderBottom: nullBorder,
      opacity: '0.12',
      borderTop: 'solid 1px #000000',
      width: '100%',
    },
  };
});

export const ExemptionCoverageId = '0058';

export interface Props {
  packageOption: number;
  onChangeExemptionCoverage: (
    modifiedPackage: number,
    addExemptionCoverage: boolean,
  ) => void;
  onChangeLoadingPackage?: () => void;
  currentSelectedPlan: string;
  unit: QuotationUnit;
}

export const ExemptionCoverage = ({
  packageOption,
  onChangeExemptionCoverage,
  onChangeLoadingPackage,
  currentSelectedPlan,
  unit,
}: Props): JSX.Element => {
  const requestingPricing = useNetworkObserver(REQUEST_PRICING);
  const [open, setOpen] = useState(false);
  const [exemptionCheked, setExemptionCheked] = useState(
    unit.coverages.some((item) => item.coverageId === ExemptionCoverageId),
  );
  const classes = useStyles();
  const theme = useTheme();
  const smQuery = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (!smQuery) setExemptionCheked(false);
  }, [currentSelectedPlan, smQuery]);

  useEffect(() => {
    setExemptionCheked(
      unit.coverages.some((item) => item.coverageId === ExemptionCoverageId),
    );
  }, [unit, smQuery]);

  const handleChangeExemption = (check: boolean) => {
    onChangeLoadingPackage?.();
    setExemptionCheked(check);
    onChangeExemptionCoverage(packageOption, check);
  };

  const isExonerationCoverageDisabled = useFeatureIsOn(
    'fwm-exemption-coverage-disabled',
  );

  return !isExonerationCoverageDisabled ? (
    <Grid>
      <ExemptionCoverageModal open={open} setOpen={setOpen} />
      <Box
        display="flex"
        justifyContent="space-between"
        style={{ paddingTop: '12px' }}
      >
        <Box display="flex">
          <Box style={{ width: '25px' }}>
            <CheckBox
              data-testid="checkbox-exemption-id"
              checkName="test"
              defaultValue={exemptionCheked}
              onChange={handleChangeExemption}
              style={{
                width: '25px !Important',
              }}
              disabled={requestingPricing === 'requesting'}
            />
          </Box>
          <Box style={{ paddingRight: '5px' }}>
            <Typography
              className={classes.labelStyle}
              data-testid="checkbox-text"
            >
              Cobertura de deducible (exoneración){' '}
              <span className={classes.newLabelStyle}>¡Nuevo!</span>
            </Typography>
          </Box>
        </Box>
        <Box
          data-testid="helper-button"
          style={{ width: '25px', textAlign: 'left' }}
          onClick={() => setOpen(true)}
        >
          <IconButton>
            <HelpCircle color={colors.bright_turquoise} size={24} />
          </IconButton>
        </Box>
      </Box>
    </Grid>
  ) : (
    <> </>
  );
};
